import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomerService from "../../Controller/CustomerController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
function CustomerCostPage({ ClientCompanyID }) {
    const navigate = useNavigate();
    ClientCompanyID = localStorage.getItem('ClientCompanyID');
    const tableRef = useRef();
    const [CustomerCostList, setCustomerCostList] = useState([]);
    const [loading, setLoading] = useState(true);
    const initDataTable = () => {
        if ($.fn.DataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        $(tableRef.current).DataTable({
            "paging": true,
            "searching": true,
            "info": true,
            order: [[0, 'desc']],
        });
    };
    useEffect(() => {
        if (CustomerCostList.length > 0) {
            initDataTable();
        }
    }, [CustomerCostList]);
    const fetchCustomerCost = async () => {
        try {
            $(tableRef.current).DataTable().destroy();
            setLoading(true);
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await CustomerService.GetCustomerCost(redirectCallback, ClientCompanyID);
            setCustomerCostList(data);
        } catch (error) {
            console.error('Error fetching Sites:', error);
        }
        finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    useEffect(() => {
        if (ClientCompanyID > 0) {
            fetchCustomerCost();
        }
    }, [ClientCompanyID]);

    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12" style={{ "textAlign": "right" }}>

                </div>
            </div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-12">
                    <div className="">
                        <table className="table m-0 table-hover" ref={tableRef}>
                            <thead>
                                <tr>
                                    <th>Cost Name</th>
                                    <th>Description</th>
                                    <th>Date</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {CustomerCostList.map((cost) => (
                                    <tr key={cost.ClientBranchID}>
                                        <td>{cost.vc_CostName}</td>
                                        <td>{cost.vc_Description}</td>
                                        <td>{formatDate(cost.dt_EntryDate)}</td>
                                        <td>{cost.mon_Cost}</td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CustomerCostPage;
